'use strict';

var _ = require('lodash');
/**
 * Applicable seasons data
 */
var ApplicableSeasonsTransformerFactory = function ApplicableSeasonsTransformerFactory(DataTransformer) {
  function ApplicableSeasonsTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'applicable-seasons';
    this.priority = 1;
  }
  ApplicableSeasonsTransformer.prototype = Object.create(DataTransformer.prototype);
  ApplicableSeasonsTransformer.constructor = ApplicableSeasonsTransformer;
  ApplicableSeasonsTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ApplicableSeasonsTransformer.prototype.isCacheable = function () {
    return false;
  };
  ApplicableSeasonsTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ApplicableSeasonsTransformer.prototype.transform = function (data) {
    var analysisDocs = data && data.domain && data.domain.analysis;
    return _.transform(analysisDocs, function (result, item) {
      result[item.origin + '-' + item.destination] = item.seasons;
      return result;
    }, {});
  };
  return ApplicableSeasonsTransformer;
};
ApplicableSeasonsTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ApplicableSeasonsTransformerFactory;